{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "S'està carregant l'editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Sistema",
    "AVATAR": {
      "SUCCESS_DELETE": "S'ha eliminat l'avatar del bot correctament",
      "ERROR_DELETE": "S'ha produït un error en eliminar l'avatar del bot, torna-ho a provar"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Nom del bot",
        "PLACEHOLDER": "Anomena el teu bot.",
        "ERROR": "El nom del bot és obligatori."
      },
      "DESCRIPTION": {
        "LABEL": "Descripció del bot",
        "PLACEHOLDER": "Què fa aquest bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Introdueix la configuració del bot CSML més amunt.",
        "API_ERROR": "La vostra configuració CSML no és vàlida. Arregla-ho i torna-ho a provar."
      },
      "SUBMIT": "Valida i desa"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Selecciona un bot d'agent",
      "DESC": "Assigna un bot d'agent a la teva safata d'entrada. Poden gestionar les converses inicials i transferir-les a un agent en directe quan sigui necessari.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Actualitza",
      "DISCONNECT": "Desconnecta el bot",
      "SUCCESS_MESSAGE": "S'ha actualitzat correctament el bot de l'agent.",
      "DISCONNECTED_SUCCESS_MESSAGE": "S'ha desconnectat correctament el bot de l'agent.",
      "ERROR_MESSAGE": "No s'ha pogut actualitzar el bot de l'agent. Torneu-ho a provar.",
      "DISCONNECTED_ERROR_MESSAGE": "No s'ha pogut desconnectar el bot de l'agent. Torneu-ho a provar.",
      "SELECT_PLACEHOLDER": "Selecciona el bot",
      "COUNTRY_BOTS": {
        "TITLE": "Bots per país",
        "DESC": "Aquesta safata d'entrada atén diversos països. Una conversa va al bot del seu país: segons la botiga de Kaufland, el mercat de la comanda d'Allegro o, si no, l'idioma en què escriu el client. Les altres converses van al bot per defecte de dalt.",
        "COUNTRY": "Selecciona un país",
        "BOT": "Selecciona el bot",
        "ADD": "Afegeix un bot per país",
        "REMOVE": "Elimina",
        "DEFAULT_REQUIRED": "Selecciona primer un bot per defecte. El bot d'un país només el substitueix per a aquest país.",
        "DISCONNECT_ALL": "Desconnecta tots els bots"
      }
    },
    "ADD": {
      "TITLE": "Configura el nou bot",
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "API": {
        "SUCCESS_MESSAGE": "Bot afegit correctament.",
        "ERROR_MESSAGE": "No s'ha pogut afegir el bot. Torneu-ho a provar més endavant."
      }
    },
    "LIST": {
      "404": "No s'han trobat bots. Pots crear un bot fent clic al botó \"Configura un bot nou\" ↗",
      "LOADING": "S'estan obtenint bots...",
      "TABLE_HEADER": {
        "DETAILS": "Detalls del bot",
        "URL": "URL del webhook"
      },
      "TYPE": "Tipus de bot"
    },
    "DELETE": {
      "BUTTON_TEXT": "Esborrar",
      "TITLE": "Suprimeix el bot",
      "CONFIRM": {
        "TITLE": "Confirma la supressió",
        "MESSAGE": "Estàs segur que vols suprimir {name}?",
        "YES": "Sí, suprimeix",
        "NO": "No, mantén"
      },
      "SUBMIT": "Esborrar",
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "DESCRIPTION": "Estàs segur que vols suprimir aquest bot? Aquesta acció és irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "S'ha esborrat el bot correctament.",
        "ERROR_MESSAGE": "No s'ha pogut eliminar el bot. Torneu-ho a provar més endavant."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Edita",
      "LOADING": "S'estan obtenint bots...",
      "TITLE": "Edita el bot",
      "CANCEL_BUTTON_TEXT": "Cancel·la",
      "API": {
        "SUCCESS_MESSAGE": "Bot actualitzat correctament.",
        "ERROR_MESSAGE": "No s'ha pogut actualitzar el bot. Torneu-ho a provar."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar del bot"
      },
      "NAME": {
        "LABEL": "Nom del bot",
        "PLACEHOLDER": "Introdueix el nom del bot"
      },
      "DESCRIPTION": {
        "LABEL": "Descripció",
        "PLACEHOLDER": "Què fa aquest bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL del webhook",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "El nom del bot és obligatori",
        "URL": "L'URL del webhook és obligatòria",
        "VALID_URL": "Introdueix una URL vàlida que comenci per http:// o https://"
      },
      "CANCEL": "Cancel·la",
      "CREATE": "Crea un bot",
      "UPDATE": "Actualitza el bot"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
